(function () {
  let lastForm = null;

  document.addEventListener(
    "click",
    function (e) {
      const f = e.target && e.target.closest && e.target.closest("form");
      if (f) lastForm = f;
    },
    true
  );

  document.addEventListener(
    "submit",
    function (e) {
      const f = e.target;
      if (f && f.tagName === "FORM") lastForm = f;
    },
    true
  );

 function propsFromForm(form) {
  const props = {};
  if (!form) return props;

  const fd = new FormData(form);
  for (const [k, v] of fd.entries()) {
    const m = k.match(/^properties\[(.+)\]$/);
    if (!m) continue;

    // Only keep explicit true values
    const val = String(v).trim().toLowerCase();
    if (val === "true" || val === "1" || val === "yes") {
      props[m[1]] = "true";
    }
  }
    return props;
  }

  function bestForm() {
    return (
      lastForm ||
      document.querySelector("#main-product form") ||
      document.querySelector("form.shopify-product-form") ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function looksLikeCartAdd(url) {
    return typeof url === "string" && url.indexOf("/cart/add.js") !== -1;
  }

  function tryPatchBodyString(bodyString) {
    if (typeof bodyString !== "string" || bodyString.length < 2) return null;

    let obj;
    try {
      obj = JSON.parse(bodyString);
    } catch (e) {
      return null;
    }

    if (!obj || !Array.isArray(obj.items) || obj.items.length < 1) return null;

    const props = propsFromForm(bestForm());
    if (!props || Object.keys(props).length === 0) return null;

    obj.items = obj.items.map(function (item) {
      const existing =
        item && item.properties && typeof item.properties === "object" ? item.properties : {};
      return Object.assign({}, item, { properties: Object.assign({}, existing, props) });
    });

    return JSON.stringify(obj);
  }

  const originalFetch = window.fetch;

  window.fetch = async function (input, init) {
    try {
      // fetch(url, init)
      if (typeof input === "string") {
        if (!looksLikeCartAdd(input)) return originalFetch.apply(this, arguments);
        if (!init || !init.body) return originalFetch.apply(this, arguments);

        const patched = tryPatchBodyString(init.body);
        if (!patched) return originalFetch.apply(this, arguments);

        const newInit = Object.assign({}, init, { body: patched });
        return originalFetch.call(this, input, newInit);
      }

      // fetch(Request, init?) or fetch(Request)
      if (input && typeof input === "object" && "url" in input) {
        const req = input;
        if (!looksLikeCartAdd(req.url)) return originalFetch.apply(this, arguments);

        // If init.body exists, patch it
        if (init && init.body) {
          const patched = tryPatchBodyString(init.body);
          if (!patched) return originalFetch.apply(this, arguments);
          const newInit = Object.assign({}, init, { body: patched });
          return originalFetch.call(this, req, newInit);
        }

        // Otherwise read the Request body and rebuild it
        const cloned = req.clone();
        const bodyText = await cloned.text().catch(() => "");
        const patched = tryPatchBodyString(bodyText);
        if (!patched) return originalFetch.apply(this, arguments);

        const newRequest = new Request(req.url, {
          method: req.method,
          headers: req.headers,
          body: patched,
          mode: req.mode,
          credentials: req.credentials,
          cache: req.cache,
          redirect: req.redirect,
          referrer: req.referrer,
          referrerPolicy: req.referrerPolicy,
          integrity: req.integrity,
          keepalive: req.keepalive,
          signal: req.signal,
        });

        return originalFetch.call(this, newRequest);
      }

      return originalFetch.apply(this, arguments);
    } catch (e) {
      return originalFetch.apply(this, arguments);
    }
  };
})();
